(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.masque-tabs').forEach(section => {
    const tabs = section.querySelectorAll('.masque-tab');

    const centerPanels = section.querySelectorAll(
        '.masque-tabs-center .masque-panel'
    );
    const descPanels = section.querySelectorAll(
        '.masque-tabs-right .masque-panel'
    );
    const sliderPanels = section.querySelectorAll(
        '.masque-content .masque-panel'
    );

    /* -------- TAB SWITCHING -------- */
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const index = Number(tab.dataset.tab);

            // reset tabs
            tabs.forEach(t => t.classList.remove('active'));

            // reset panels
            centerPanels.forEach(p => p.classList.remove('active'));
            descPanels.forEach(p => p.classList.remove('active'));
            sliderPanels.forEach(p => p.classList.remove('active'));

            // activate current
            tab.classList.add('active');
            centerPanels[index]?.classList.add('active');
            descPanels[index]?.classList.add('active');
            sliderPanels[index]?.classList.add('active');

            // reset slider position on tab change
            const activeTrack =
            sliderPanels[index]?.querySelector('.masque-track');
            if (activeTrack) {
            activeTrack.style.transform = 'translateX(0)';
            }
        });
    });

    function setCenterImagesHeight(section) {
        const row1 = section.querySelector('.masque-row1');
        const row2 = section.querySelector('.masque-row2');
        const center = section.querySelector('.masque-tabs-center');
        const panels = section.querySelectorAll('.masque-tabs-center .masque-panel');
        const images = section.querySelectorAll('.masque-tabs-center img');

        if (!row1 || !row2 || !center) return;

        const isMobile = window.innerWidth <= 768;

        let totalHeight =
            row1.getBoundingClientRect().height +
            row2.getBoundingClientRect().height;

        if (isMobile) {
            totalHeight -= 170; // 👈 adjust value as needed
        }

        // set height everywhere that needs it
        center.style.height = `${totalHeight}px`;

        panels.forEach(panel => {
            panel.style.height = `${totalHeight}px`;
        });

        images.forEach(img => {
            img.style.width = 'auto';
            img.style.height = 'auto';
            img.style.objectFit = 'contain';
        });


    }


    document.querySelectorAll('.masque-tabs').forEach(section => {
        const row1 = section.querySelector('.masque-row1');
        const row2 = section.querySelector('.masque-row2');

        const resizeObserver = new ResizeObserver(() => {
            setCenterImagesHeight(section);
        });

        if (row1) resizeObserver.observe(row1);
        if (row2) resizeObserver.observe(row2);

        // initial
        setCenterImagesHeight(section);

        // on resize
        window.addEventListener('resize', () => {
            setCenterImagesHeight(section);
        });

        // on tab change
        section.querySelectorAll('.masque-tab').forEach(tab => {
            tab.addEventListener('click', () => {
            setTimeout(() => {
                setCenterImagesHeight(section);
            }, 60);
            });
        });
    });

    document.querySelectorAll('.masque-slider').forEach(slider => {
        const track = slider.querySelector('.masque-track');

        const slides = Array.from(
            track.querySelectorAll('.masque-slide:not(.static)')
            ).map(slide => {
            const img = slide.querySelector('img');
            const text = slide.querySelector('.slide_text');

            return {
                img: img ? img.src : '',
                text: text ? text.innerHTML : ''
            };
        });

        if (slides.length < 3) return;

        let index = 0;

        const slot1 = track.querySelector('.slot-1');
        const slot2 = track.querySelector('.slot-2');
        const slot4 = track.querySelector('.slot-4');

        function render() {
            const s1 = slides[index % slides.length];
            const s2 = slides[(index + 1) % slides.length];
            const s3 = slides[(index + 2) % slides.length];

            slot1.innerHTML = s1
                ? `<img src="${s1.img}" alt="">
                <div class="slide_text">${s1.text}</div>`
                : '';

            slot2.innerHTML = s2
                ? `<img src="${s2.img}" alt="">
                <div class="slide_text">${s2.text}</div>`
                : '';

            slot4.innerHTML = s3
                ? `<img src="${s3.img}" alt="">
                <div class="slide_text">${s3.text}</div>`
                : '';
        }

        slider.querySelector('.next')?.addEventListener('click', () => {
            index = (index + 1) % slides.length;
            render();
        });

        slider.querySelector('.prev')?.addEventListener('click', () => {
            index = (index - 1 + slides.length) % slides.length;
            render();
        });

        // initial paint
        render();
    });

});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masque-tabs-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.masque-tabs').forEach(section => {
    const tabs = section.querySelectorAll('.masque-tab');

    const centerPanels = section.querySelectorAll(
        '.masque-tabs-center .masque-panel'
    );
    const descPanels = section.querySelectorAll(
        '.masque-tabs-right .masque-panel'
    );
    const sliderPanels = section.querySelectorAll(
        '.masque-content .masque-panel'
    );

    /* -------- TAB SWITCHING -------- */
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const index = Number(tab.dataset.tab);

            // reset tabs
            tabs.forEach(t => t.classList.remove('active'));

            // reset panels
            centerPanels.forEach(p => p.classList.remove('active'));
            descPanels.forEach(p => p.classList.remove('active'));
            sliderPanels.forEach(p => p.classList.remove('active'));

            // activate current
            tab.classList.add('active');
            centerPanels[index]?.classList.add('active');
            descPanels[index]?.classList.add('active');
            sliderPanels[index]?.classList.add('active');

            // reset slider position on tab change
            const activeTrack =
            sliderPanels[index]?.querySelector('.masque-track');
            if (activeTrack) {
            activeTrack.style.transform = 'translateX(0)';
            }
        });
    });

    function setCenterImagesHeight(section) {
        const row1 = section.querySelector('.masque-row1');
        const row2 = section.querySelector('.masque-row2');
        const center = section.querySelector('.masque-tabs-center');
        const panels = section.querySelectorAll('.masque-tabs-center .masque-panel');
        const images = section.querySelectorAll('.masque-tabs-center img');

        if (!row1 || !row2 || !center) return;

        const isMobile = window.innerWidth <= 768;

        let totalHeight =
            row1.getBoundingClientRect().height +
            row2.getBoundingClientRect().height;

        if (isMobile) {
            totalHeight -= 90; // 👈 adjust value as needed
        }

        // set height everywhere that needs it
        center.style.height = `${totalHeight}px`;

        panels.forEach(panel => {
            panel.style.height = `${totalHeight}px`;
        });

        images.forEach(img => {
            img.style.height = `${totalHeight}px`;
            img.style.width = '100%';
            img.style.objectFit = 'contain';
        });
    }


    document.querySelectorAll('.masque-tabs').forEach(section => {
        const row1 = section.querySelector('.masque-row1');
        const row2 = section.querySelector('.masque-row2');

        const resizeObserver = new ResizeObserver(() => {
            setCenterImagesHeight(section);
        });

        if (row1) resizeObserver.observe(row1);
        if (row2) resizeObserver.observe(row2);

        // initial
        setCenterImagesHeight(section);

        // on resize
        window.addEventListener('resize', () => {
            setCenterImagesHeight(section);
        });

        // on tab change
        section.querySelectorAll('.masque-tab').forEach(tab => {
            tab.addEventListener('click', () => {
            setTimeout(() => {
                setCenterImagesHeight(section);
            }, 60);
            });
        });
    });

    document.querySelectorAll('.masque-slider').forEach(slider => {
        const track = slider.querySelector('.masque-track');

        // collect ONLY real slides (exclude static slot)
        const slides = Array.from(
            track.querySelectorAll('.masque-slide:not(.static)')
            ).map(slide => {
            const img = slide.querySelector('img');
            const text = slide.querySelector('.slide_text');

            return {
                img: img ? img.src : '',
                text: text ? text.innerHTML : ''
            };
        });

        if (slides.length < 3) return;

        let index = 0;

        const slot1 = track.querySelector('.slot-1');
        const slot2 = track.querySelector('.slot-2');
        const slot4 = track.querySelector('.slot-4');

        function render() {
            const s1 = slides[index % slides.length];
            const s2 = slides[(index + 1) % slides.length];
            const s3 = slides[(index + 2) % slides.length];

            slot1.innerHTML = s1
                ? `<img src="${s1.img}" alt="">
                <div class="slide_text">${s1.text}</div>`
                : '';

            slot2.innerHTML = s2
                ? `<img src="${s2.img}" alt="">
                <div class="slide_text">${s2.text}</div>`
                : '';

            slot4.innerHTML = s3
                ? `<img src="${s3.img}" alt="">
                <div class="slide_text">${s3.text}</div>`
                : '';
        }

        slider.querySelector('.next')?.addEventListener('click', () => {
            index = (index + 1) % slides.length;
            render();
        });

        slider.querySelector('.prev')?.addEventListener('click', () => {
            index = (index - 1 + slides.length) % slides.length;
            render();
        });

        // initial paint
        render();
    });

});




  } catch(e) { console.error(e); }
})();
})();
